import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup";
import { PermissionCategoryModel } from "services/api/cplauthapi/CPLAuthAPI";
import { container } from "setup/dependency/inversify.config";
import { IPermissionsService } from "services/PermissionsService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

const initialState = {
  SelectedPermissionCategory: new PermissionCategoryModel(),
  PermissionCategories: new Array<PermissionCategoryModel>(),
  LoadingPermissionCategories: false,
};

export const permissionCategoriesSlice = createSlice({
  name: "permissionCategories",
  initialState,
  reducers: {
    setSelectedPermissionCategory: (state, action) => {
      state.SelectedPermissionCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllPermissionCategories.pending, (state) => {
      state.LoadingPermissionCategories = true;
    });
    builder.addCase(fetchAllPermissionCategories.fulfilled, (state, action) => {
      state.PermissionCategories = action.payload;
      state.SelectedPermissionCategory = action.payload[0];
      state.LoadingPermissionCategories = false;
    });
    builder.addCase(fetchAllPermissionCategories.rejected, (state) => {
      state.PermissionCategories = new Array<PermissionCategoryModel>();
      state.SelectedPermissionCategory = new PermissionCategoryModel();
      state.LoadingPermissionCategories = false;
    });
  },
});

export const fetchAllPermissionCategories = createAsyncThunk(
  "PermissionCategories/FetchAllPermissionCategories",
  async () => {
    const permissionsService = container.get<IPermissionsService>(SERVICE_TYPES.PermissionService);
    return await permissionsService.getAllPermissionCategories();
  }
);

export const { setSelectedPermissionCategory } = permissionCategoriesSlice.actions;

export const selectLoadingPermissionCategories = (state: RootState) => {
  return state.permissionCategories.LoadingPermissionCategories;
};

export const selectSelectedPermissionCategory = (state: RootState) => {
  return state.permissionCategories.SelectedPermissionCategory;
};

export const selectPermissionCategories = (state: RootState) => {
  return state.permissionCategories.PermissionCategories;
};

export default permissionCategoriesSlice.reducer;
